import { AppDispatch } from "@frontend/redux/store";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { DEFAULT_WEATHER_PARAMS } from "./constants";
import { fetchAndCacheWeather } from "./fetchAndCacheWeather";

export function WeatherInitializer() {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(fetchAndCacheWeather({ params: DEFAULT_WEATHER_PARAMS }));
  }, [dispatch]);
  return null;
}
